import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import CardsSection from '@/pages/home/components/CardsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import AboutSection from '@/pages/home/components/AboutSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import AppSection from '@/pages/home/components/AppSection';
import ContactSection from '@/pages/home/components/ContactSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import IndexSection from '@/pages/home/components/IndexSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-200">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <RankingSection />
        <AboutSection />
        <TopicsSection />
        <FaqSection />
        <CommentsSection />
        <CarouselSection />
        <AppSection />
        <ContactSection />
        <FeaturesSection />
        <IndexSection />
        <UpdatesSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}